import { render, staticRenderFns } from "./OpenTable.vue?vue&type=template&id=6d7e5a36&scoped=true&"
import script from "./OpenTable.vue?vue&type=script&lang=js&"
export * from "./OpenTable.vue?vue&type=script&lang=js&"
import style0 from "./OpenTable.vue?vue&type=style&index=0&id=6d7e5a36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7e5a36",
  null
  
)

export default component.exports